import { TimeControl } from "@chesshotel/constants";
import { chooseGame } from "../../redux/lobby";
import { getModeId } from "../../util/util";

export function saveAndChooseGame(time, inc, variant, turnLength, timeControl) {
  const modeId = getModeId(time, variant, timeControl);

  chooseGame({ time, inc, variant, modeId, turnLength, timeControl });

  // turnLength = turnLength?.toString() || null;
  // inc = inc?.toString() || null;
  // time = time?.toString() || null;
  // variant = variant?.toString() || null;

  try {
    if (timeControl == TimeControl.LIVE) {
      localStorage.setItem("chosenTime", time);
    } else {
      localStorage.setItem("turnLength", turnLength);
    }

    localStorage.setItem("timeControl", timeControl);
    localStorage.setItem("chosenInc", inc);
    localStorage.setItem("chosenVariant", variant);
  } catch (e) {
    console.log(e);
  }
}
